// extracted by mini-css-extract-plugin
module.exports = {"skip-button-previous-sibling":"SkipToContent_skip-button-previous-sibling__32qvc","skip-to-content":"SkipToContent_skip-to-content__1saJe"};